<template>
  <div class="privacy-policy-page">
    <!-- Start cyber Main Menu Area -->
    <div
      id="sticky-header"
      class="cyber_nav_manu d-md-none d-lg-block d-sm-none d-none"
    >
      <div class="container">
        <div class="row align-items-center">
          <div class="navbar-content">
            <div class="logo">
              <a class="logo_img" href="/" title="ipipbright">
                <img :src="require('../assets/images/ipipbright.png')" style="height: 73px;" alt="" />
              </a>
            </div>
            <nav class="cyber_menu">
              <ul class="nav_scroll">
                <li><router-link to="/" class="nav-link">{{ t.home }}</router-link></li>
                <li>
                  <router-link to="/" class="nav-link active">{{ t.services }}</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/dynamic">{{ t.serviceDynamic }}</router-link></li>
                  </ul>
                </li>
                <li><router-link to="/faq" class="nav-link">{{ t.tutorial }}</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/faq">{{ t.faq }}</router-link></li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0);" >{{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}</a>
                  <ul class="sub-menu">
                    <li><a href="javascript:void(0);" @click="setLanguage('en')">English</a></li>
                    <li><a href="javascript:void(0);" @click="setLanguage('zh')">简体中文</a></li>
                  </ul>
                </li>
              </ul>
              <div class="auth-buttons">
                <router-link to="/login" class="auth-btn login-btn">{{ t.login }}</router-link>
                <router-link to="/register" class="auth-btn register-btn">{{ t.register }}</router-link>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-menu-area d-sm-block d-md-block d-lg-none">
      <div class="mobile-menu-container">
        <div class="mobile-menu-header">
          <div class="mobile-menu-logo">
            <a href="/" title="ipipbright">
              <img :src="require('../assets/images/ipipbright.png')" style="height: 40px; margin: 10px 0 0 15px;" alt="ipipbright" />
            </a>
          </div>
          <!-- <a href="javascript:void(0);" class="mobile-menu-toggle" @click="toggleMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </a> -->
        </div>
        <div class="mobile-menu-body" v-show="isMobileMenuOpen">
          <ul class="mobile-menu-list">
            <li class="mobile-menu-item"><a href="javascript:void(0);" class="mobile-menu-link" @click="handleMobileNavClick('/')">{{ t.home }}</a></li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="#home" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'Package')">{{ t.services }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'Package')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'Package'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="handleMobileNavClick('/dynamic')">{{ t.serviceDynamic }}</a></li>
              </ul>
            </li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="/faq" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'Tutorial')">{{ t.tutorial }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'Tutorial')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'Tutorial'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="handleMobileNavClick('/faq')">{{ t.faq }}</a></li>
              </ul>
            </li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="#language" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'English')" >{{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'English')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'English'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="setLanguage('en')">English</a></li>
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="setLanguage('zh')">简体中文</a></li>
              </ul>
            </li>
          </ul>
          <div class="mobile-auth-buttons">
            <a href="javascript:void(0);" class="mobile-auth-btn mobile-login-btn" @click="handleMobileNavClick('/login')">{{ t.login }}</a>
            <a href="javascript:void(0);" class="mobile-auth-btn mobile-register-btn" @click="handleMobileNavClick('/register')">{{ t.register }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- End cyber Main Menu Area -->

    <!-- Banner Section -->
    <section class="faq-banner-section ptb-100">
      <div class="container">
        <div class="banner-content text-center">
          <h1>{{ t.privacyPolicyTitle }}</h1>
          <p>{{ t.privacyPolicySubtitle }}</p>
        </div>
      </div>
    </section>
    <!-- End Banner Section -->

    <!-- Privacy Policy Content Section -->
    <section class="policy-content-section ptb-100 bg-light">
      <div class="container">
        <div class="policy-content">
          <div class="policy-header">
            <h2>{{ languageState.currentLanguage === 'en' ? privacyData.title1 : privacyDataZh.title1 }}</h2>
            <div class="policy-meta">
              <span>{{ languageState.currentLanguage === 'en' ? privacyData.title2 : privacyDataZh.title2 }}</span>
              <span>{{ languageState.currentLanguage === 'en' ? privacyData.title3 : privacyDataZh.title3 }}</span>
            </div>
          </div>
          
          <div class="policy-body">
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title55 : privacyDataZh.title55 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title4 : privacyDataZh.title4 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title5 : privacyDataZh.title5 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title6 : privacyDataZh.title6 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title7 : privacyDataZh.title7 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title8 : privacyDataZh.title8 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title9 : privacyDataZh.title9 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title10 : privacyDataZh.title10 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title11 : privacyDataZh.title11 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title12 : privacyDataZh.title12 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title13 : privacyDataZh.title13 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title14 : privacyDataZh.title14 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title15 : privacyDataZh.title15 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title16 : privacyDataZh.title16 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title17 : privacyDataZh.title17 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title18 : privacyDataZh.title18 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title19 : privacyDataZh.title19 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title20 : privacyDataZh.title20 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title21 : privacyDataZh.title21 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title22 : privacyDataZh.title22 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title23 : privacyDataZh.title23 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title24 : privacyDataZh.title24 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title25 : privacyDataZh.title25 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title26 : privacyDataZh.title26 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title27 : privacyDataZh.title27 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title28 : privacyDataZh.title28 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title29 : privacyDataZh.title29 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title30 : privacyDataZh.title30 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title31 : privacyDataZh.title31 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title32 : privacyDataZh.title32 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title33 : privacyDataZh.title33 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title34 : privacyDataZh.title34 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title35 : privacyDataZh.title35 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title36 : privacyDataZh.title36 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title37 : privacyDataZh.title37 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? privacyData.title38 : privacyDataZh.title38 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title39 : privacyDataZh.title39 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title40 : privacyDataZh.title40 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title41 : privacyDataZh.title41 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title42 : privacyDataZh.title42 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title43 : privacyDataZh.title43 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? privacyData.title44 : privacyDataZh.title44 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title45 : privacyDataZh.title45 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? privacyData.title46 : privacyDataZh.title46 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title47 : privacyDataZh.title47 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title48 : privacyDataZh.title48 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title49 : privacyDataZh.title49 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title50 : privacyDataZh.title50 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title51 : privacyDataZh.title51 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title52 : privacyDataZh.title52 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title53 : privacyDataZh.title53 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? privacyData.title54 : privacyDataZh.title54 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title56 : privacyDataZh.title56 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title57 : privacyDataZh.title57 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title58 : privacyDataZh.title58 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title59 : privacyDataZh.title59 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title60 : privacyDataZh.title60 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title61 : privacyDataZh.title61 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title62 : privacyDataZh.title62 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title63 : privacyDataZh.title63 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title64 : privacyDataZh.title64 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title65 : privacyDataZh.title65 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title66 : privacyDataZh.title66 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title67 : privacyDataZh.title67 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title68 : privacyDataZh.title68 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title69 : privacyDataZh.title69 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title70 : privacyDataZh.title70 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title71 : privacyDataZh.title71 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title72 : privacyDataZh.title72 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title73 : privacyDataZh.title73 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title74 : privacyDataZh.title74 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title75 : privacyDataZh.title75 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title76 : privacyDataZh.title76 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title77 : privacyDataZh.title77 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title78 : privacyDataZh.title78 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title79 : privacyDataZh.title79 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title80 : privacyDataZh.title80 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title81 : privacyDataZh.title81 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title82 : privacyDataZh.title82 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title83 : privacyDataZh.title83 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title84 : privacyDataZh.title84 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title85 : privacyDataZh.title85 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title86 : privacyDataZh.title86 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title87 : privacyDataZh.title87 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title88 : privacyDataZh.title88 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title89 : privacyDataZh.title89 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title90 : privacyDataZh.title90 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title91 : privacyDataZh.title91 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title92 : privacyDataZh.title92 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title93 : privacyDataZh.title93 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title94 : privacyDataZh.title94 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title95 : privacyDataZh.title95 }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Privacy Policy Content Section -->

    <!-- Footer Area -->
    <div class="footer-middle" id="footer">
      <div class="container">
        <div class="row">
          <!--footer widget 1 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div class="widget widgets_company_info">
              <h2 class="widget-title">IPIPBright</h2>
              <div class="company_info_desc">
                <p>
                  {{ t.footerDesc }}
                </p>
              </div>
              <div class="social_media">
                <h3>{{ t.followUs }}</h3>
                <a href="javascript:void(0);"><i class="fa-brands fa-facebook-f"></i></a>
                <a href="javascript:void(0);"><i class="fa-brands fa-linkedin-in"></i></a>
                <a href="javascript:void(0);"><i class="fa-brands fa-telegram"></i></a>
              </div>
            </div>
          </div>

          <!--footer widget 2 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div id="em_recent_post_widget-8" class="widget widget_recent_data">
              <div class="single-widget-item">
                <h2 class="widget-title">{{ t.quickLinks }}</h2>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/"> {{ t.home }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/privacy"> {{ t.privacyPolicy }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/service-policy"> {{ t.servicePolicy }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/faq"> {{ t.faq }} </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--footer widget 3 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div id="em_recent_post_widget-7" class="widget widget_recent_data">
              <div class="single-widget-item">
                <h2 class="widget-title">{{ t.productServices }}</h2>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/dynamic"> {{ t.serviceDynamic }} </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--footer widget 4 -->
          <div class="col-lg-3 col-md-6 col-xs-12 last">
            <div class="widget widget_get_quote">
              <h2 class="widget-title">{{ t.contactUs }}</h2>
              <div class="widget_get_quote_content">
                <div class="widget_quote_text">
                  <div class="footer_quote_text_decripsition">
                    <div class="footer_quote_decripsition_inner">
                      <p>
                        {{ t.supportText }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Footer Area -->
    
    <!-- Footer Bottom Area -->
    <div class="footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="footer-bottom-content">
              <p>{{ t.copyright }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Footer Bottom Area -->

    <!-- Simple go to top button -->
    <div 
      id="simple-go-top" 
      @click="scrollToTop"
      style="
        position: fixed;
        bottom: 30px;
        right: 30px;
        width: 55px;
        height: 55px;
        background: linear-gradient(135deg, #1581c6, #1581c6);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 9999999;
        font-size: 26px;
        font-weight: bold;
        box-shadow: 0 8px 25px rgba(21, 129, 198, 0.6);
        transition: all 0.3s ease;
        opacity: 0;
        visibility: hidden;
        border: none;
      "
    >
      ↑
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  inject: ['changeLanguage', 'languageState'],
  data() {
    return {
      // 页面文本国际化配置
      i18n: {
        en: {
            home: 'Home',
            services: 'Package',
            serviceDynamic: 'Dynamic residence',
            serviceStatic: 'Static residence',
            blog: 'Tutorial Center',
            tutorial: 'Tutorial',
            faq: 'FAQs',
            signIn: 'Sign In',
            signUp: 'Sign Up',
            login: 'Login',
            register: 'Register',
            learnMore: 'Buy Now',
            privacyPolicyTitle: 'Privacy Policy',
            privacyPolicySubtitle: 'Learn about how we protect your privacy',
            footerDesc: 'Your trusted partner for high-quality proxy services with global coverage and exceptional performance.',
            quickLinks: 'Quick Links',
            productServices: 'Product Services',
            contactUs: 'Contact Us',
            supportText: '24/7 technical support, ready to answer your questions and provide professional IP proxy solutions.',
            copyright: 'ipipbright. © 2024 All Rights Reserved.',
            privacyPolicy: 'Privacy Policy',
            servicePolicy: 'Service Policy',
            followUs: 'Follow Us'
          },
          zh: {
            home: '首页',
            services: '动态套餐',
            serviceDynamic: '动态住宅',
            serviceStatic: '静态住宅',
            blog: '教程中心',
            tutorial: '教程中心',
            faq: '常见问题',
            signIn: '登录',
            signUp: '注册',
            login: '登录',
            register: '注册',
            learnMore: '立即购买',
            privacyPolicyTitle: '隐私政策',
            privacyPolicySubtitle: '了解我们如何保护您的隐私',
            footerDesc: '您值得信赖的高质量代理服务合作伙伴，提供全球覆盖和卓越性能。',
            quickLinks: '快速链接',
            productServices: '产品服务',
            contactUs: '联系我们',
            supportText: '24/7技术支持，随时为您解答问题，提供专业的IP代理解决方案。',
            copyright: 'ipipbright. © 2024 保留所有权利。',
            privacyPolicy: '隐私政策',
            servicePolicy: '服务政策',
            followUs: '关注我们'
          }
      },
      isSticky: false,
      isNavCollapsed: true,
      isMobileMenuOpen: false,
      activeDropdown: '',
      showGoTop: false,
      // 隐私政策数据
      privacyData: {
        title1: 'ipipbright privacy agreement',
        title2: 'The latest update time of the agreement: July 15, 2023',
        title3: 'Agreement effective date: July 15, 2023',
        title55: 'Special Note',
        title4: 'Thank you for choosing and using ipipbright service.',
        title5: 'For the purpose of facilitating your registration, login and use of ipipbright related services, we may collect, save, use and share your information. ipipbright attaches great importance to the protection of your information, and we will take corresponding security protection measures in accordance with legal and regulatory requirements. We will use this "ipipbright Privacy Agreement" (hereinafter referred to as "this Agreement") to explain and describe to you how we collect, use, store and share your information when you use the products and services provided by ipipbright, and how we Methods provided for you to access, update, control and protect this information.',
        title6: 'Unless otherwise stated by ipipbright or otherwise agreed with you, the terms in this Privacy Agreement have the same meanings as those used in the "ipipbright User Service Agreement".',
        title7: 'Please read this agreement carefully. When you confirm your acceptance of this agreement by checking the box online or by using ipipbright services, you will be deemed to have fully read, understood and agreed to be bound by this agreement. This agreement will take legal effect between you and ipipbright. ',
        title8: '1. Scope of application of this agreement',
        title9: '1.1 This agreement only applies to the products and service functions (hereinafter referred to as the "services") provided by ipipbright (hereinafter referred to as "we" or "ipipbright")',
        title10: '1.2 This agreement also applies to services and functions upgraded and updated by ipipbright based on product development, including but not limited to websites, interfaces, customized programs, and derivative products and services that emerge with technological development.',
        title11: '1.3 This agreement applies to all information and materials submitted when you register and use ipipbright, as well as information collected by ipipbright to provide you with services.',
        title12: '1.4 This agreement does not apply to products/services provided by other third parties. For example, you obtain and use products/services provided by third parties through the ipipbright website. The above-mentioned service agreement, usage policy and the legal relationship established between you and the third party need to be confirmed. Other information needs to be determined separately by you and the service provider.',
        title13: '1.5 If a product/service we provide has a separate privacy policy (including special agreements in its corresponding various agreements), the privacy policy and special agreements of the product/service will take precedence and the privacy of the product/service If the policy is not stipulated or the stipulation is unclear and there is no special agreement, the content of this agreement shall prevail.',
        title14: '2. Information we collect',
        title15: '2.1 You know and agree that we will collect your information in the following ways:',
        title16: '2.1.1 When registering a ipipbright account, you actively submit your mobile phone number information, real-name information, set and confirm your login password, etc.',
        title17: '2.1.2 In special circumstances, you entrust and authorize our employees or partners to upload and submit relevant information on your behalf, such as your corresponding information that you entrust our customer service staff to fill in and upload.',
        title18: '2.1.3 The information we actively collect when you use our services includes but is not limited to:',
        title19: '(1) Operation records, we will receive and record the operation records, log records and related information of your use of the ipipbright service.',
        title20: '(2) Contract information, if you need offline delivery, etc., you should provide necessary information such as contact person, contact information, address, invoicing information, order, etc.',
        title21: '2.2 When you perform real-name authentication, you need to provide your name, ID card, mobile phone number, facial information and other information according to the prompts on the web page. Only after your account passes these certifications and verifications can you be qualified to use related products/services. Please confirm that you submit legal, true, and valid information.',
        title22: '2.3 If you register ipipbright in the name of a company, you need to submit your company name, unified social credit code, scanned copy or photo of business license, bank account information (including opening bank, bank account number and Account holder), and screenshots of corporate transfers. We will verify your identity based on the information you submitted.',
        title23: '2.4 If you need to join the promotion plan or become a ipipbright agent, you need to sign a separate relevant agreement. To perform the contract, you should provide necessary information such as contact person and contact information.',
        title24: '2.5 The contract and other material information you signed when you used our customer service or participated in events organized by us.',
        title25: '2.6 Other information, such as consultation communication records.',
        title26: 'As our business develops, the product functions and services we provide may be adjusted and changed. If the purpose of processing changes, we will explain it to you again and obtain your consent. We will keep the above information for at least 6 months. All operation records will be fully logged and will be permanently sealed after 6 months.',
        title27: '3. How we use the collected information',
        title28: 'In order to provide you with high-quality, convenient and safe services, we use the information collected for the following purposes. If we use your information beyond the following purposes, we will explain it to you again and obtain your consent.',
        title29: '3.1 Provide services to you.',
        title30: '3.2 To achieve the purpose stipulated in the "Information We Collect" in this Agreement.',
        title31: '3.3 Push product news, ipipbright updates and other related business news and commercial advertisements to you. For example, Teng ipipbright can use your mobile phone number, email and other contact information to push commercial advertisements to you through text messages, phone calls, emails and other methods to publicize and promote ipipbright services.',
        title32: '3.4 Invite you to participate in surveys about our products and services.',
        title33: '3.5 Improve, optimize and improve ipipbright online services.',
        title34: '3.6 Report to relevant departments in accordance with laws, regulations or regulatory requirements.',
        title35: '4. Information we share, transfer and publicly disclose',
        title36: 'We will only share, transfer, publicly disclose, and entrust the processing of your information within the legal, legitimate, and necessary scope with your explicit authorization/consent and in compliance with relevant laws and regulations.',
        title37: '4.1 Sharing',
        title38: 'In order to provide you with more complete and high-quality products/services, we may share your information with our third-party partners. At this time, we will sign a strict confidentiality agreement with our partners, requiring them to handle your personal information in accordance with our instructions, this privacy policy, and any other relevant confidentiality and security measures. Except as stipulated by laws and regulations and as otherwise agreed between ipipbright and you, we will not share your information with any unrelated third party without your consent.',
        title39: 'If you refuse our partners to collect the personal information necessary to provide services when providing services, you may not be able to use the third-party services on our platform. Usually our partners fall into the following categories:',
        title40: '4.1.1 Service providers that provide functional support for our products/services: such as payment institutions that provide payment services (Alipay, WeChat, public account transfers), and verification institutions that provide real-name authentication functions.',
        title41: '4.1.2 Information promotion and advertising partners: You confirm that we have the right to share our use of your relevant information with information promotion and advertising partners to form indirect user portraits, de-identification or anonymization. Analytical/statistical information and de-identified user device identification codes to help them make advertising or decision-making recommendations, improve the effective reach rate of advertising, and further understand user needs.',
        title42: '4.2 Transfer',
        title43: 'We will not transfer your personal information to any company, organization or individual except with your express consent. As our business continues to develop, we may conduct spin-offs, mergers, acquisitions, asset transfers or similar transactions, and your information may be transferred as part of such transactions. We will inform you of the name of the recipient and require the recipient to continue to be bound by this Privacy Policy. If the recipient changes the purpose and method of processing personal information agreed in this privacy policy, we will require the recipient to obtain your authorization and consent again.',
        title44: '4.3 Information disclosure',
        title45: 'Except for public disclosure in compliance with laws and regulations or under the following circumstances, we will not publicly disclose your personal information that has not been disclosed by yourself or otherwise has not been legally disclosed. The following exceptions apply.',
        title46: '4.3.1 Disclose to third parties with your prior consent.',
        title47: '4.3.2 If you are a qualified intellectual property complainant and have filed a complaint, you shall disclose it to the respondent at the request of the respondent so that both parties can handle possible rights disputes.',
        title48: '4.3.3 Disclose to third parties or administrative or judicial authorities in accordance with the relevant provisions of the law or the requirements of administrative or judicial authorities.',
        title49: '4.3.4 If you violate relevant Chinese laws and regulations or the ipipbright service agreement or related rules, you need to disclose it to a third party.',
        title50: '4.3.5 In order to provide the products and services you request, your personal information must be shared with third parties.',
        title51: '4.3.6 In a transaction on ipipbright, if any party to the transaction fulfills or partially fulfills the transaction obligations and makes a request for information disclosure, ipipbright has the right to decide to provide the user with the contact information of the counterparty and other necessary information to facilitate the transaction. completion or dispute resolution.',
        title52: '4.3.7 Other disclosures that ipipbright deems appropriate in accordance with laws, regulations or website policies.',
        title53: '4.4. Exceptions to sharing, transferring, and publicly disclosing your personal information',
        title54: 'In accordance with relevant laws and other regulations, we may share, transfer, or publicly disclose your information without your consent in the following circumstances:',
        title56: '4.4.1 Necessary to provide the corresponding functions or services in "II. The information we collect" and necessary for the purposes described in the section "III. How we use the information we collect".',
        title57: '4.4.2 Perform our obligations and exercise our rights in the "ipipbright User Service Agreement" or this Agreement.',
        title58: '4.4.3 Necessary to perform legal duties or obligations, such as those directly related to national security, national defense security, criminal investigation, prosecution, trial and judgment execution, etc.',
        title59: '4.4.4 In order to respond to public health emergencies, or necessary to protect the life, health and property safety of natural persons in emergency situations.',
        title60: '4.4.5 Conduct news reporting, public opinion supervision and other activities for the public interest, and process personal information within a reasonable scope.',
        title61: '4.4.6 Personal information disclosed by users to the public.',
        title62: '4.4.7 Collect personal information from legally publicly disclosed information, such as legal news reports, government information disclosure and other channels.',
        title63: '5. How we use cookies and related technologies',
        title64: 'When you use our products/services, we may use cookies and similar technologies to collect some of your personal information, such as your website access habits, browsing information, login information, etc. The specific purposes for which we use cookies include:',
        title65: '5.1 Remember who you are. For example: Cookies help us identify you as our registered user, eliminating the need to repeatedly enter your account number in order to use our services.',
        title66: '5.2 Analyze your use of our services, understand the specific purposes for which you use our services, and which web pages or services are most popular with you, so as to provide you with more thoughtful and personalized services.',
        title67: '5.3 You can refuse or manage Cookies through your browser settings. However, please note that if you disable Cookies, you may not be able to use our related products/services normally or obtain the best service experience through our products/services, and the availability of certain functions may be affected.',
        title68: '5.4 This agreement will also apply to relevant information recorded through ipipbright Cookie.',
        title69: '6. Information storage location and period',
        title70: '6.1 We will take reasonable and feasible measures to avoid collecting irrelevant user information. We will only retain your user information for the period necessary to achieve the purposes stated in this policy, unless permitted by law. After the above user information retention period expires, we will delete or anonymize your personal information.',
        title71: 'However, we may need to retain your information or part of it for a longer period of time under the following circumstances:',
        title72: '6.1.1 We should store it for a long time in accordance with laws, regulations and other relevant regulations.',
        title73: '6.1.2 We are required to store the effective judgments, rulings or other legal procedures of the court for a long time',
        title74: '6.1.3 The administrative, judicial or other competent authorities require us to preserve it for a long time.',
        title75: '6.1.4 It is necessary to execute relevant service agreements or this privacy agreement, handle complaints/disputes, or protect social interests, the personal and property safety of others, or other legitimate rights and interests.',
        title76: '7. Information security',
        title77: '7.1 In order to prevent the loss, improper use, unauthorized reading or disclosure of information, we will strive to use the following security technologies and measures to protect your user information:',
        title78: '7.1.1 We take various reasonable physical, electronic and managerial security measures to protect your user information. Protect user information from unauthorized access, public disclosure, use, modification, damage or loss.',
        title79: '7.1.2 We have established strict management systems and processes to ensure information security. For example, we strictly limit the scope of personnel who can access information. Only authorized personnel can access user information, and require relevant personnel to abide by confidentiality obligations.',
        title80: '7.1.3 If a user information security incident (leakage, loss, etc.) unfortunately occurs, we will promptly inform you by sending emails, push notifications, announcements, etc.: the basic situation and possible impact of the security incident, the measures we have taken or will take Disposal measures taken, suggestions for you to prevent and reduce risks on your own, remedial measures for you, etc. At the same time, we will also report the handling of user information security incidents in accordance with the requirements of regulatory authorities.',
        title81: '7.2 In order to better protect your information security, we recommend that you strengthen your self-protection awareness and measures. Please keep your information properly to avoid leakage. We will only be liable to the extent that your information is leaked directly due to ipipbrights fault.',
        title82: '8. How do you manage your own information?',
        title83: 'During your use of our services, you can access and modify your user information. We will collect, use and store your information in accordance with legal and regulatory requirements or as agreed by both parties.',
        title84: '9. Changes to the Agreement',
        title85: '9.1 Due to policy changes, business adjustments, changes in technology and services, etc., we reserve the right to revise the terms of this Agreement, and such revisions form part of this Agreement. We will notify you by publishing on our official website before the updated Privacy Agreement takes effect. Your continued use of our services after notification shall constitute your agreement to accept the revised content. We will not reduce your rights under this Agreement unless you expressly agree. If the aforementioned revisions may result in a substantial reduction or significant change in your rights under this Agreement, we will seek your express consent again.',
        title86: '9.2 Major changes include but are not limited to:',
        title87: '9.2.1 Our service model undergoes significant changes. Such as the purpose of processing personal information, types of personal information processed, how personal information is used, etc.',
        title88: '9.2.2 We undergo major changes in ownership structure, organizational structure, etc. Such as changes in owners caused by business adjustments, bankruptcy mergers, etc.',
        title89: '9.2.3 The main [... 12918 chars omitted ...]',
        title90: '9.2.4 Other circumstances that may have a significant impact on your rights and interests as stipulated by laws and regulations.',
        title91: '10. Your rights',
        title92: '10.1 You have the right to access, correct, supplement, delete and other rights to your personal information in accordance with laws and regulations. You can exercise these rights through the following channels:',
        title93: '10.1.1 Log in to your account and modify your personal information in the "Personal Center";',
        title94: '10.1.2 Contact our customer service to make a request. You can contact our customer service through the contact information published on the ipipbright official website;',
        title95: '10.2 When you exercise your rights, we may ask you to verify your identity to ensure the security of your account.'
        // ... (other privacy policy data)
      },
      privacyDataZh: {
        title1: 'ipipbright 隐私协议',
        title2: '协议最新更新时间：2023年7月15日',
        title3: '协议生效日期：2023年7月15日',
        title4: '感谢您选择并使用 ipipbright 服务。',
        title5: '为了便于您注册、登录和使用 ipipbright 相关服务，我们可能会收集、保存、使用和分享您的信息。ipipbright 重视对您信息的保护，我们将按照法律、法规要求采取相应的安全保护措施。我们将通过本《ipipbright 隐私协议》（以下简称 "本协议"）向您说明和描述您在使用 ipipbright 提供的产品和服务时，我们如何收集、使用、存储和分享您的信息，以及我们为您提供的访问、更新、控制和保护此类信息的方式。',
        title6: '除非 ipipbright 另有说明或与您另有约定，否则本隐私协议中的术语与《ipipbright 用户服务协议》中使用的术语具有相同的含义。',
        title7: '请您仔细阅读本协议。当您通过勾选在线确认或以使用 ipipbright 服务的方式确认接受本协议，即表示您已充分阅读、理解并同意受本协议约束。本协议将在您与 ipipbright 之间产生法律效力。',
        title8: '1. 本协议的适用范围',
        title9: '1.1 本协议仅适用于 ipipbright（以下简称 "我们" 或 "ipipbright"）提供的产品和服务功能（以下简称 "服务"）',
        title10: '1.2 本协议也适用于 ipipbright 基于产品开发升级和更新的服务和功能，包括但不限于网站、接口、定制程序以及随着技术发展出现的衍生产品和服务。',
        title11: '1.3 本协议适用于您注册和使用 ipipbright 时提交的所有信息和资料，以及 ipipbright 为您提供服务而收集的信息。',
        title12: '1.4 本协议不适用于其他第三方提供的产品/服务。例如，您通过 ipipbright 网站获取和使用第三方提供的产品/服务。上述服务协议、使用政策以及您与第三方之间建立的法律关系需要另行确认。其他信息需要由您与服务提供商另行确定。',
        title13: '1.5 如果我们提供的某个产品/服务有单独的隐私政策（包括其对应的各项协议中的特别约定），则该产品/服务的隐私政策和特别约定优先适用，若该产品/服务的隐私政策未作规定或规定不明确且无特别约定的，则以本协议内容为准。',
        title14: '2. 我们收集的信息',
        title15: '2.1 您知悉并同意，我们将通过以下方式收集您的信息：',
        title16: '2.1.1 在注册 ipipbright 账户时，您主动提交您的手机号码信息、实名信息，设置并确认您的登录密码等。',
        title17: '2.1.2 在特殊情况下，您委托并授权我们的员工或合作伙伴代为上传和提交相关信息，例如您委托我们的客服人员填写和上传的您的相应信息。',
        title18: '2.1.3 您使用我们服务时，我们主动收集的信息包括但不限于：',
        title19: '(1) 操作记录，我们将接收并记录您使用 ipipbright 服务的操作记录、日志记录和相关信息。',
        title20: '(2) 合同信息，若您需要线下交付等，您应提供联系人、联系方式、地址、开票信息、订单等必要信息。',
        title21: '2.2 当您进行实名认证时，您需要根据网页提示提供姓名、身份证、手机号码、面部信息等信息。您的账户只有通过这些认证和验证后，才能有资格使用相关产品/服务。请您确认提交的信息合法、真实、有效。',
        title22: '2.3 若您以公司名义注册 ipipbright，您需要提交公司名称、统一社会信用代码、营业执照扫描件或照片、银行账户信息（包括开户行、银行账号和账户名），以及企业转账截图。我们将根据您提交的信息验证您的身份。',
        title23: '2.4 若您需要加入推广计划或成为 ipipbright 代理，您需要签署单独的相关协议。为履行合同，您应提供联系人、联系方式等必要信息。',
        title24: '2.5 您在使用我们的客服或参加我们组织的活动时签署的合同等材料信息。',
        title25: '2.6 其他信息，如咨询沟通记录。',
        title26: '随着我们业务的发展，我们提供的产品功能和服务可能会有所调整和变化。若处理目的发生变更，我们将再次向您说明并征得您的同意。我们将保留上述信息至少 6 个月。所有操作记录将被完整记录，并在 6 个月后永久封存。',
        title27: '3. 我们如何使用收集的信息',
        title28: '为了向您提供高质量、便捷和安全的服务，我们将收集的信息用于以下目的。若我们将您的信息用于超出以下目的的用途，我们将再次向您说明并征得您的同意。',
        title29: '3.1 向您提供服务。',
        title30: '3.2 实现本协议中 "我们收集的信息" 中规定的目的。',
        title31: '3.3 向您推送产品新闻、ipipbright 更新和其他相关业务新闻及商业广告。例如，腾 ipipbright 可以利用您的手机号码、电子邮件等联系信息，通过短信、电话、电子邮件等方式向您推送商业广告，宣传和推广 ipipbright 服务。',
        title32: '3.4 邀请您参与有关我们产品和服务的调查。',
        title33: '3.5 改进、优化和完善 ipipbright 在线服务。',
        title34: '3.6 根据法律、法规或监管要求向相关部门报告。',
        title35: '4. 我们共享、转让和公开披露的信息',
        title36: '我们仅在法律、合法、必要的范围内，在您明确授权/同意的情况下，并遵循相关法律法规，共享、转让、公开披露和委托处理您的信息。',
        title37: '4.1 共享',
        title38: '为了向您提供更完整、高质量的产品/服务，我们可能会与我们的第三方合作伙伴共享您的信息。此时，我们会与合作伙伴签订严格的保密协议，要求他们按照我们的指示、本隐私政策以及任何其他相关的保密和安全措施处理您的个人信息。除非法律法规另有规定或 ipipbright 与您另有约定，否则我们不会在未获得您同意的情况下将您的信息与任何无关第三方共享。',
        title39: '如果您拒绝我们的合作伙伴在提供服务时收集必要的个人信息，您可能无法使用我们平台上的第三方服务。通常我们的合作伙伴分为以下几类：',
        title40: '4.1.1 为我们的产品/服务提供功能支持的服务提供商：例如提供支付服务的支付机构（支付宝、微信、公账转账），提供实名认证功能的验证机构。',
        title41: '4.1.2 信息推广和广告合作伙伴：您确认我们有权与信息推广和广告合作伙伴共享我们对您相关信息的使用，以形成间接用户画像、去标识化或匿名化的分析/统计信息以及去标识化的用户设备识别码，帮助他们进行广告或决策推荐，提高广告的有效到达率，进一步了解用户需求。',
        title42: '4.2 转让',
        title43: '除非获得您的明确同意，否则我们不会将您的个人信息转让给任何公司、组织或个人。随着我们业务的不断发展，我们可能会进行分立、合并、收购、资产转让或类似交易，您的信息可能会作为此类交易的一部分被转让。我们将通知您接收方的名称，并要求接收方继续受本隐私政策的约束。如果接收方变更了本隐私政策中约定的个人信息处理目的和方式，我们将要求接收方再次获得您的授权和同意。',
        title44: '4.3 信息披露',
        title45: '除非根据法律法规规定进行公开披露或在以下情况下，否则我们不会公开披露您未自行披露或未依法披露的个人信息。以下情况除外。',
        title46: '4.3.1 经您事先同意向第三方披露。',
        title47: '4.3.2 如果您是合格的知识产权投诉人并已提出投诉，应被投诉人的要求，向被投诉人披露，以便双方处理可能的权利纠纷。',
        title48: '4.3.3 根据法律的相关规定或行政、司法机关的要求向第三方或行政、司法机关披露。',
        title49: '4.3.4 如果您违反了相关中国法律法规或 ipipbright 服务协议或相关规则，需要向第三方披露。',
        title50: '4.3.5 为了提供您请求的产品和服务，您的个人信息必须与第三方共享。',
        title51: '4.3.6 在 ipipbright 上的交易中，如果交易任何一方履行或部分履行了交易义务并提出信息披露请求，ipipbright 有权决定向用户提供交易对方的联系方式等必要信息，以方便交易完成或纠纷解决。',
        title52: '4.3.7 ipipbright 根据法律、法规或网站政策认为适当的其他披露。',
        title53: '4.4. 共享、转让和公开披露您个人信息的例外情况',
        title54: '根据相关法律和其他法规，在以下情况下，我们可以在未获得您同意的情况下共享、转让或公开披露您的信息：',
        title56: '4.4.1 提供 "二、我们收集的信息" 中相应功能或服务所必需，以及 "三、我们如何使用收集的信息" 部分所述目的所必需。',
        title57: '4.4.2 履行我们在《ipipbright 用户服务协议》或本协议中的义务和行使我们的权利。',
        title58: '4.4.3 履行法律义务或职责所必需，例如与国家安全、国防安全、刑事侦查、起诉、审判和判决执行等直接相关的。',
        title59: '4.4.4 为了应对突发公共卫生事件，或保护自然人的生命、健康和财产安全等紧急情况下所必需。',
        title60: '4.4.5 为公共利益进行新闻报道、舆论监督等活动，并在合理范围内处理个人信息。',
        title61: '4.4.6 用户向公众披露的个人信息。',
        title62: '4.4.7 从合法公开披露的信息中收集个人信息，例如合法的新闻报道、政府信息公开等渠道。',
        title63: '5. 我们如何使用 Cookie 和相关技术',
        title64: '当您使用我们的产品/服务时，我们可能会使用 Cookie 和类似技术收集您的一些个人信息，例如您的网站访问习惯、浏览信息、登录信息等。我们使用 Cookie 的具体目的包括：',
        title65: '5.1 记住您是谁。例如：Cookie 帮助我们识别您是我们的注册用户，无需在使用我们服务时反复输入您的账号。',
        title66: '5.2 分析您对我们服务的使用情况，了解您使用我们服务的具体目的，以及哪些网页或服务最受您欢迎，从而为您提供更贴心、个性化的服务。',
        title67: '5.3 您可以通过浏览器设置拒绝或管理 Cookie。但请注意，如果您禁用 Cookie，您可能无法正常使用我们的相关产品/服务或通过我们的产品/服务获得最佳服务体验，某些功能的可用性可能会受到影响。',
        title68: '5.4 本协议也适用于通过 ipipbright Cookie 记录的相关信息。',
        title69: '6. 信息存储地点和期限',
        title70: '6.1 我们将采取合理可行的措施，避免收集无关的用户信息。我们仅会在实现本政策所述目的所必需的期限内保留您的用户信息，除非法律允许。上述用户信息保留期限届满后，我们将删除或匿名化您的个人信息。',
        title71: '但是，在以下情况下，我们可能需要更长时间保留您的信息或其部分信息：',
        title72: '6.1.1 根据法律、法规和其他相关规定，我们应当长期保存的。',
        title73: '6.1.2 法院的有效判决、裁定或其他法律程序要求我们长期保存的',
        title74: '6.1.3 行政、司法或其他主管部门要求我们长期保存的。',
        title75: '6.1.4 执行相关服务协议或本隐私协议、处理投诉/纠纷，或保护社会利益、他人的人身和财产安全或其他合法权益所必需。',
        title76: '7. 信息安全',
        title77: '7.1 为防止信息丢失、不当使用、未经授权的读取或披露，我们将努力使用以下安全技术和措施保护您的用户信息：',
        title78: '7.1.1 我们采取各种合理的物理、电子和管理安全措施来保护您的用户信息。保护用户信息免受未经授权的访问、公开披露、使用、修改、损坏或丢失。',
        title79: '7.1.2 我们建立了严格的管理体系和流程，确保信息安全。例如，我们严格限制能够访问信息的人员范围。只有授权人员才能访问用户信息，并要求相关人员遵守保密义务。',
        title80: '7.1.3 如果不幸发生用户信息安全事件（泄露、丢失等），我们将通过发送电子邮件、推送通知、公告等方式及时通知您：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您自行防范和降低风险的建议、对您的补救措施等。同时，我们也将按照监管部门的要求报告用户信息安全事件的处理情况。',
        title81: '7.2 为了更好地保护您的信息安全，我们建议您加强自我保护意识和措施。请妥善保管您的信息，避免泄露。我们仅对因 ipipbright 直接过错导致您信息泄露的情况承担责任。',
        title82: '8. 您如何管理自己的信息？',
        title83: '在您使用我们服务期间，您可以根据法律法规的规定对您的个人信息行使访问、更正、补充、删除等权利。您可以通过以下渠道行使这些权利：',
        title84: '9. 协议的变更',
        title85: '9.1 由于政策变更、业务调整、技术和服务变化等原因，我们保留修改本协议条款的权利，此类修改构成本协议的一部分。在更新后的隐私协议生效前，我们将通过在官方网站上发布的方式通知您。您在通知后继续使用我们的服务，即表示您同意接受修改后的内容。除非您明确同意，否则我们不会减少您在本协议下的权利。如果上述修改可能导致您在本协议下的权利大幅减少或发生重大变化，我们将再次征求您的明确同意。',
        title86: '9.2 重大变更包括但不限于：',
        title87: '9.2.1 我们的服务模式发生重大变化。例如，处理个人信息的目的、处理的个人信息类型、如何使用个人信息等。',
        title88: '9.2.2 我们的所有权结构、组织结构等发生重大变化。例如，业务调整、破产合并等导致所有者变更。',
        title89: '9.2.3 主要...',
        title90: '9.2.4 法律法规规定的可能对您的权益产生重大影响的其他情况。',
        title91: '10. 您的权利',
        title92: '10.1 您有权根据法律法规的规定对您的个人信息行使访问、更正、补充、删除等权利。您可以通过以下渠道行使这些权利：',
        title93: '10.1.1 登录您的账户，在 "个人中心" 修改您的个人信息；',
        title94: '10.1.2 联系我们的客服提出请求。您可以通过 ipipbright 官方网站上公布的联系方式联系我们的客服；',
        title95: '10.2 当您行使权利时，我们可能会要求您验证身份，以确保您账户的安全。'
      },
      animationFrameId: null
    };
  },
  computed: {
    // 获取当前语言的文本
    t() {
      const lang = this.languageState.currentLanguage;
      return this.i18n[lang] || this.i18n.en;
    }
  },
  methods: {
    // 设置语言
    setLanguage(lang) {
      this.changeLanguage(lang);
      this.activeDropdown = '';
    },
    // 切换移动端菜单
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    // 处理移动端导航链接点击
    handleMobileNavClick(targetRoute) {
      // 检查是否为当前路由，避免重复导航错误
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
      // 无论是否导航，都关闭菜单
      this.isMobileMenuOpen = false;
      this.activeDropdown = '';
    },
    // 切换下拉菜单
    toggleDropdown(event, dropdownName) {
      event.preventDefault();
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = '';
      } else {
        this.activeDropdown = dropdownName;
      }
    },
    // 滚动到顶部
    scrollToTop() {
      console.log('scrollToTop called');
      
      // 方法1：使用window.location.href直接跳转到页面顶部
      try {
        window.location.href = '#';
      } catch (e) {
        console.error('Method 1 failed:', e);
      }
      
      // 方法2：使用document.documentElement.scrollIntoView
      try {
        document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        console.error('Method 2 failed:', e);
      }
      
      // 方法3：使用document.body.scrollIntoView
      try {
        document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        console.error('Method 3 failed:', e);
      }
      
      // 方法4：直接设置scrollTop为0
      try {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch (e) {
        console.error('Method 4 failed:', e);
      }
      
      // 方法5：查找所有可能的滚动容器并设置scrollTop为0
      try {
        const scrollableElements = document.querySelectorAll('div, section, main, body, html');
        scrollableElements.forEach(el => {
          if (el.scrollTop > 0) {
            el.scrollTop = 0;
          }
        });
      } catch (e) {
        console.error('Method 5 failed:', e);
      }
    }
  },
  mounted() {
    // 使用requestAnimationFrame定期检查滚动位置
    const checkScrollPosition = () => {
      // 同时检查window.scrollY和document.documentElement.scrollTop，确保在不同浏览器中都能获取到正确的滚动位置
      const scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop
      const goTopBtn = document.getElementById('simple-go-top')
      if (goTopBtn) {
        if (scrollY > 300) {
          goTopBtn.style.opacity = '1'
          goTopBtn.style.visibility = 'visible'
        } else {
          goTopBtn.style.opacity = '0'
          goTopBtn.style.visibility = 'hidden'
        }
      }
      // 更新isSticky状态
      this.isSticky = scrollY > 50
      
      // 继续下一帧检查
      this.animationFrameId = requestAnimationFrame(checkScrollPosition)
    }
    
    // 启动requestAnimationFrame循环
    this.animationFrameId = requestAnimationFrame(checkScrollPosition)
  },
  beforeDestroy() {
    // 取消requestAnimationFrame循环
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId)
    }
  }
}
</script>

<style scoped>
/* Desktop menu sticky styles */
#sticky-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #32312d;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: auto;
}

/* Mobile menu container */
.mobile-menu-container {
  position: relative;
  z-index: 99999;
}

/* Mobile menu header sticky styles */
.mobile-menu-header {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 99999;
  background: #32312d;
  min-height: 60px;
  padding: 4px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Mobile menu body should be fixed to viewport */
.mobile-menu-body {
  position: fixed !important;
  top: 60px;
  left: 0;
  right: 0;
  /* Make menu height smaller than full viewport */
  max-height: 70vh;
  margin-top: 0;
  z-index: 99998;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.95) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border: none !important;
}

/* Make menu list background transparent */
.mobile-menu-list {
  background: transparent !important;
}

/* Make menu items background transparent */
.mobile-menu-item {
  background: transparent !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
}

/* Adjust menu link styles */
.mobile-menu-link {
  color: #fff !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.mobile-menu-link:hover {
  color: #1581c6 !important;
  transform: translateX(10px);
  background: rgba(21, 129, 198, 0.1);
}

.mobile-menu-link::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: #1581c6;
  transform: scaleY(0);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu-link:hover::before {
  transform: scaleY(1);
}

.mobile-menu-expand {
  color: #fff !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu-expand:hover {
  color: #1581c6 !important;
  transform: rotate(180deg) scale(1.2);
}

.mobile-sub-menu {
  background: rgba(255, 255, 255, 0.08) !important;
  max-height: 300px;
  padding: 15px 0;
  animation: fadeInUp 0.4s ease forwards;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-sub-menu-link {
  color: #fff !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.mobile-sub-menu-link:hover {
  color: #1581c6 !important;
  transform: translateX(15px);
  background: rgba(21, 129, 198, 0.15);
}

.mobile-sub-menu-link::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 3px;
  height: 100%;
  background: #1581c6;
  transform: scaleY(0);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-sub-menu-link:hover::before {
  transform: scaleY(1);
}

.mobile-auth-btn {
  color: #fff !important;
  background: rgba(21, 129, 198, 0.3) !important;
  border: 1px solid rgba(21, 129, 198, 0.5) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-auth-btn:hover {
  background: rgba(21, 129, 198, 0.5) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(21, 129, 198, 0.4);
}

/* Mobile menu toggle button */
.mobile-menu-toggle {
  width: 40px;
  height: 40px;
  padding: 10px;
  cursor: pointer;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 15px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.mobile-menu-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
}

.mobile-menu-toggle span {
  display: block;
  background: #fff;
  height: 3px;
  width: 24px;
  margin: 2px 0;
  transition: all 0.3s ease;
  border-radius: 2px;
}

/* Banner Section */
.faq-banner-section {
  margin-top: 100px;
  background-color: #2d2c28 !important;
}

/* Remove margin-top on mobile */
@media (max-width: 768px) {
  .faq-banner-section {
    margin-top: 0;
  }
}
</style>

<style scoped>
/* CSS Variables */
:root {
  --fontFamily: 'Nunito', sans-serif;
  --mainColor: #4146E6;
  --optionalColor: #6F8BA4;
  --whiteColor: #ffffff;
  --blackColor: #3B566E;
  --fontSize: 16px;
  --transition: .5s;
}

/* Container Styles */
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

/* Padding Styles */
.ptb-100 {
  padding-top: 100px;
  padding-bottom: 100px;
}

/* Background Styles */
.bg-light {
  background-color: #2d2c28 !important;
}

/* Global Text Color */
h1, h2, h3, h4, h5, h6, p, li, span {
  color: white !important;
}

/* Policy Meta Styles */
.policy-meta {
  color: white !important;
}

.policy-meta span {
  color: white !important;
}
</style>